import { ClockIn } from './clock-in.model';
import { Operation } from './operation.model';

import moment from 'moment';


/**
 * Clase para manejar las fichadas:
 * 
 *  - Actual
 *  - Backup
 *  - Manual
 *  - Última 
 *  - Historial
 *  - OFs internas
 *  - Operario OF manual
 *  - Fecha OF manual
 * 
 * 
 *
 * @export
 * @class Clocking
 */
export class Clocking{


    /**
     * Contiene la fichada actual.
     *
     * @private
     * @type {ClockIn}
     * @memberof Clocking
     */
    private _current: ClockIn = new ClockIn();


    /**
     * Contiene una copia de la fichada actual.
     *
     * @private
     * @type {ClockIn}
     * @memberof Clocking
     */
    private _backup: ClockIn = new ClockIn();


    /**
     * Contiene los datos de la fichada manual.
     *
     * @private
     * @type {ClockIn}
     * @memberof Clocking
     */
    private _manually: ClockIn = new ClockIn();


    /**
     * Contiene el historial de fichadas.
     *
     * @private
     * @type {Array<ClockIn>}
     * @memberof Clocking
     */
    private _history: Array<ClockIn> = [];


    /**
     * 
     * Contiene la última fichada.
     *
     * @private
     * @type {ClockIn}
     * @memberof Clocking
     */
    private _last: ClockIn = new ClockIn();


    /**
     * Contiene la lista interna de OFs.
     *
     * @private
     * @type {Array<ClockIn>}
     * @memberof Clocking
     */
    private _internal: Array<ClockIn> = [];

    /**
     * Contiene el operador de la fichada manual.
     * 
     * @private
     * @type {string}
     * @memberof Clocking
     * @deprecated Eliminar esta opción? Puede ser necesaria para diferenciar el operador de la vista manual.
     */
    private _operator: string = '';

    /**
     * Contiene el nombre del operador de la fichada manual.
     *
     * @private
     * @type {string}
     * @memberof Clocking
     */
    private _opName: string = '';

    /**
     * Contiene el filtro de fecha para las fichadas manuales.
     *
     * @private
     * @type {string}
     * @memberof Clocking
     */
    //private _date: string = '2018-07-12'; //@TODO: Eliminar linia. Només proves
    private _date: string = moment().format('YYYY-MM-DD');


    /**
     * Contiene el indice de la fichada del historial seleccionada.
     *
     * @private
     * @type {number}
     * @memberof Clocking
     */
    private _hIndex: number = null;
    
    /**
     * Devuelve la fichada actual.
     *
     * @type {ClockIn}
     * @memberof Clocking
     */
    get current(): ClockIn{
        return this._current;
    }

    /**
     * Establece la fichada actual.
     *
     * @memberof Clocking
     */
    set current(clockIn: ClockIn){
        this._current = clockIn;
    }

    /**
     * Devuelve la fichada manual.
     *
     * @type {ClockIn}
     * @memberof Clocking
     */
    get manually(): ClockIn{
        return this._manually;
    }

    /**
     * Establece la fichada manual.
     *
     * @memberof Clocking
     */
    set manually(clockIn: ClockIn){
        this._manually = clockIn;
    }


    /**
     * Devuelve la última fichada.
     *
     * @type {ClockIn}
     * @memberof Clocking
     */
    get last(): ClockIn{
        return this._last;
    }


    /**
     * Establece la última fichada.
     *
     * @memberof Clocking
     */
    set last(clockIn: ClockIn){
        this._last = clockIn;
    }



    /**
     * Devuelve el historial de fichadas .
     *
     * @type {Array<ClockIn>}
     * @memberof Clocking
     */
    get history(): Array<ClockIn>{
        return this._history;
    }


    /**
     * Establece el historial de fichadas.
     *
     * @memberof Clocking
     */
    set history(history: Array<ClockIn>){
        this._history = history;
    }

    /**
     * Devuelve las OF internas
     *
     * @type {Array<ClockIn>}
     * @memberof Clocking
     */
    get internal(): Array<ClockIn>{
        return this._internal;
    }


    /**
     * Establece la lista de OFs internas.
     *
     * @memberof Clocking
     */
    set internal(internal: Array<ClockIn>){
        this._internal = internal;
    }

    /**
     * Operador de las fichadas manuales getter.
     *
     * @memberof Clocking
     */
    get operator(){
        return this._operator;
    }

    /**
     * Operador de las fichadas manuales setter .
     *
     * @memberof Clocking
     */
    set operator(operator: string){
        this._operator = operator;
    }

    /**
     * Devuelve el nombre del operador manual.
     *
     * @type {string}
     * @memberof Clocking
     */
    get opName(): string{
        return this._opName;
    }

    /**
     * Establece el nombre del operador manual.
     *
     * @memberof Clocking
     */
    set opName(name: string){
        this._opName = name;
    }


   
  
    /**
     * Fecha getter.
     * 
     * Devuelve la fecha en formato local 'L'.
     *
     * @type {string}
     * @memberof ManuallyClocking
     */
    get date(): string{
        let parseDate = moment(this._date,'YYYYMMDD').format('L');
        return parseDate;
    }

    /**
     * Fecha setter.
     * 
     * El formato debe ser YYYYMMDD.
     *
     * @memberof ManuallyClocking
     */
    set date(date: string){
        this._date = date;
    }


    /**
     * Devuelve el indice seleccionado del historial.
     *
     * @type {number}
     * @memberof Clocking
     */
    get hIndex(): number{
        if(!this.history.length) return null;
        return this._hIndex;
    }

    /**
     * Establece el indice seleccionado del historial.
     *
     * @memberof Clocking
     */
    set hIndex(index: number){
        if(!this.history.length) index = null;
        this._hIndex = index;
    }

    /**
     * Devuelve la última Orden de fabricación.
     *
     * @returns {string}
     * @memberof Clocking
     */
    getLastMO(): string{
        return this._last.manufacturingOrder;
    }

    
    /**
     * Devuelve el nombre de la última operación.
     *
     * @returns
     * @memberof Clocking
     */
    getLastOperationName(){
        return this._last.getOperationName();
    }

     /**
     * Devuelve el/los nombre del último producto
     * separados por comas si hay mas de uno.
     *
     * @returns
     * @memberof Clocking
     */
    getLastProductsNames(){
        return this._last.getProductsList();
    }
    
    /**
     * Devuelve la fichada del historial actual.
     *
     * @returns {ClockIn} La fichada actual. Si hIndex === null una fichada vacía.
     * @memberof Clocking
     */
    getManuallyInHistory(): ClockIn{
        if(this.hIndex === null) return new ClockIn();
        return this._history[this.hIndex];
    }


    /**
     * Actualiza el historial de fichadas con la fichada manual.
     *
     * @memberof Clocking
     */
    setManuallyInHistory(): void{
        if(this.hIndex == null) this.history.push(this.manually.copy());
        else this.history[this.hIndex] = this.manually.copy();
    }

    deleteIndexInHistory(index: number = null){
        if(index === null) return;
        this.history.splice(index,1);
        this.hIndex = null;
    } 

    /**
     * Indica si la fichada actual no está iniciada.
     *
     * @returns {boolean}
     * @memberof Clocking
     */
    isCurrentEmpty(): boolean{
        return this.current.isEmpty();
    }

    /**
     * Indica si la última fichada no está iniciada.
     *
     * @returns {boolean}
     * @memberof Clocking
     */
    isLastEmpty(): boolean{
        return this.last.isEmpty();
    }



    
    /**
     * Inicia la fichada actual con formate YYYY-MM-DD HH:mm:ss.
     *
     * @param {string} [date=moment().format('YYYY-MM-DD HH:mm:ss')]
     * @memberof Clocking
     */
    startCurrent(date: string = moment().format('YYYY-MM-DD HH:mm:ss')): void{
        this.current.start = date;
    }
    
    /**
     * Devuelve el tiempo transcurrido de la fichada actual.
     * Si se especifica {end}, calcula el tiempo hasta esta fecha.
     *
     * @param {string} end
     * @returns
     * @memberof Clocking
     */
    getCurrentElapsedTime(end?: string){
        return this.current.calcPartialTime(end);
    }

    /**
     * Termina la fichada actual.
     *
     * @memberof Clocking
     */
    endCurrent(): void{
        this.current.end = moment().format('YYYY-MM-DD HH:mm:ss');
        this.current.time = this.current.calcTotalTime();
       // if(this.current.start) this.history.push(this.current.copy());

        this.current.operator = '';
        this.current.manufacturingOrder = '';
        this.current.operation = new Operation();
        this.current.products = [];
        this.current.order = '';
        this.current.client = '';
        this.current.start = null;
        this.current.end = null;

        this.setLastOperatorOrder();
    }


    /**
     * Assigna una OF interna como actual.
     *
     * @param {number} [index=0]
     * @returns {ClockIn}
     * @memberof Clocking
     */
    setInternalAsCurrent(index: number = 0): ClockIn{
        if(index<0 || index>=this.internal.length) return null;
        let internal = this.internal[index].copy();
        internal.operator = this.current.operator; //Assign current operator
        this.current = internal;
        return this.current;
    }

    /**
     * Resetea las variables de clase.
     *
     * @memberof Clocking
     */
    reset(){
        this.current.reset();
        this.last.reset();
        this.history = [];
        this.internal = [];
        this.opName = '';
        this.operator = '';
    }


    /**
     * Inicia la lista de OFs interna.
     *
     * @param {Array<any>} list
     * @memberof Clocking
     */
    setInteralMOsFromResponse(list: Array<any>){
        if(!Array.isArray(list)) return;
        this.internal = Array.apply(null, {length: list.length}).map( (item, index)=> new ClockIn()); //Crea el array de OFs interna
        list.forEach((item, index)=> this.internal[index].setFromResponse(item)); //Inicia los elementos con los datos de la respuesta
    }

    /**
     * Inicia el historial de fichadas desde una respuesta http.
     *
     * @param {Array<any>} list
     * @returns {Array<ClockIn}
     * @memberof Clocking
     */
    setHistoryFromResponse(list: Array<any>): Array<ClockIn>{
        if(!Array.isArray(list)) return;
        this.history = Array.apply(null, {length: list.length}).map( (item, index)=> new ClockIn()); //Crea el array del historial
        list.forEach((item, index)=> this.history[index].setFromResponseHistory(item)); //Inicia los elementos con los datos de la respuesta
        return  this.history;
    }


    /**
     * Guarda una copia de la fichada actual.
     *
     * @memberof Clocking
     */
    saveCurrent(): void{
        this._backup = this.current.copy();
    }


    /**
     * Recupera la copia de la fichada actual si está iniciada.
     *
     * @memberof Clocking
     */
    restoreCurrent(): void{
        this._current = this._backup.copy();
    }


    /**
     * Devuelve el numero total de horas.
     *
     * @returns {number} La suma de las horas del historial.
     * @memberof Clocking
     */
    getHistorySum(): number{
        if(!this.history.length) return 0;
        return this.history.map(item=>parseFloat(item.time)).reduce((a,b)=> a + b, 0);


    }

    
    /**
     * Devuelve la fichada guardada.
     *
     * @returns {ClockIn} La fichada de backup.
     * @memberof Clocking
     */
    getBackup(): ClockIn{
        return this._backup;
    }

    /**
     *  @ignore
     *
     * @param {string} [operator=this.current.operator]
     * @returns {ClockIn}
     * @memberof Clocking
     */
    getLastOperatorOrder(operator:string = this.current.operator): ClockIn{
        let clockInByOp = this.history.filter(clockIn=>{
            return clockIn.operator == operator?true:false;
        });

        if(clockInByOp.length) return clockInByOp[clockInByOp.length-1];
        else return new ClockIn();
    }


    /**
     *  @ignore
     *
     * @param {string} [operator=this.current.operator]
     * @memberof Clocking
     */
    setLastOperatorOrder(operator:string = this.current.operator){
        let mo = this.getLastOperatorOrder();
        this.last = mo.copy();
    }



    /**
     *  @ignore
     *
     * @param {*} start
     * @param {*} days
     * @returns {Date}
     * @memberof Clocking
     */
    randomDateAfterDate(start, days): Date {
        return new Date(start.getTime() + (Math.random()*days*24*60*60*1000)); 
        //randomDate(new Date(2012, 0, 1), new Date())
        //var item = items[Math.floor(Math.random()*items.length)];
    }



    /**
     *  @ignore
     *
     * @param {string} [code=null]
     * @returns
     * @memberof Clocking
     */
    getMockProducts(code: string = null){
        return [
            {code: '0592A0001-00', 'desc': 'TAPA EXTERIOR DELANTERA'},
            {code: '0592A0002-00', 'desc': 'TAPA EXTERIOR TRASERA'}
        ]
    }


    /**
     *  @ignore
     *
     * @param {string} [code=null]
     * @returns
     * @memberof Clocking
     */
    getMockOperations(code: string = null){
        return [
            {code: '7', order: 1, 'desc': 'PUNXONAR'},
            {code: '56', order: 2, 'desc': 'PINTAR'},
            {code: '1', order: 2, 'desc': 'PLEGAR'},
            {code: '15', order: 3, 'desc': 'ETIQUETAR'},
            {code: '56', order: 3, 'desc': 'PINTAR'},
            {code: '15', order: 4, 'desc': 'ETIQUETAR'}
        ]
    }
}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/clocking.model.ts